enum RelativeTime {
    YESTERDAY = 'yesterday',
}

export default RelativeTime;
